import { create } from 'zustand';

/**
 * Global app UI state.
 * Auth + org data stays in AuthContext.
 * Server/data state lives in page-level hooks (see hooks/useDashboardData.js).
 */
export const useAppStore = create((set) => ({
  sidebarExpanded: true,
  setSidebarExpanded: (expanded) => set({ sidebarExpanded: expanded }),
  toggleSidebar: () => set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),
}));

export default useAppStore;
